import ExcelJS from 'exceljs';

import { formatDate } from '../../../../../../../../../lib/functions/utils';

const statusMap: Record<string, string> = {
  PENDING: 'En espera',
  CLOSED: 'Completado',
};

export const exportEntryToXLXS = async (entry: any, nodes: any[]) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Asiento');

  // Información del encabezado
  worksheet.addRow(['ID Comprobante:', entry.id]);
  worksheet.addRow(['Fecha:', formatDate(entry.date)]);
  worksheet.addRow(['Glosa asiento:', entry.name]);
  worksheet.addRow(['Estado:', statusMap[entry.status]]);
  worksheet.addRow([]); // Fila vacía

  // Configurar anchos de columnas
  worksheet.getColumn(1).width = 15;
  worksheet.getColumn(2).width = 30;
  worksheet.getColumn(3).width = 30;
  worksheet.getColumn(4).width = 15;
  worksheet.getColumn(5).width = 15;

  // Agregar cabeceras de las columnas de líneas
  const headerRow = worksheet.addRow([
    'Código Cuenta',
    'Cuenta',
    'Glosa línea',
    'Debe',
    'Haber',
  ]);
  headerRow.font = { bold: true };

  // Agregar líneas del asiento
  entry.lines.forEach((line: any) => {
    const node = nodes.find((n: any) => n.id === line.nodeId);
    worksheet.addRow([
      node?.accountCode || '',
      node?.key || '',
      line.description || '',
      line.debit || 0,
      line.credit || 0,
    ]);
  });

  // Calcular totales
  const totalDebit = entry.lines.reduce(
    (sum: number, line: any) => sum + (line.debit || 0),
    0,
  );
  const totalCredit = entry.lines.reduce(
    (sum: number, line: any) => sum + (line.credit || 0),
    0,
  );

  // Agregar fila de totales
  worksheet.addRow([]);
  const totalRow = worksheet.addRow([
    '',
    '',
    'TOTALES',
    totalDebit,
    totalCredit,
  ]);
  totalRow.font = { bold: true };

  // Generar archivo
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `Asiento_${entry.id}_${formatDate(entry.date)}.xlsx`;
  link.click();
  window.URL.revokeObjectURL(url);
};
